import { __rest } from "tslib";
import React from 'react';
import { useCurrentUser, usePermissions, userSelectors, } from '@marvelapp/ballpark-application';
import { ProjectVisibility } from '@marvelapp/core';
import { Link } from '@marvelapp/ui';
import { Badge } from './Badge';
import { BtwSettingsItem } from './BtwSettingsItem';
import { SettingsItem } from './SettingsItem';
import { SettingsToggle } from './SettingsToggle';
import { Stack } from './Stack';
/**
 * @deprecated Use
 * ```
 * import { BtwInviteOnlySetting } from '@marvelapp/ballpark-components'
 * ```
 * instead
 */
export function InviteOnlySetting(_a) {
    var { onToggle, visibility } = _a, settingItemProps = __rest(_a, ["onToggle", "visibility"]);
    const user = useCurrentUser();
    const permissions = usePermissions();
    const isLockedFreePlan = userSelectors.isLockedFreePlan(user);
    const isStarterPlan = userSelectors.isPro(user);
    const canUpgrade = isStarterPlan || isLockedFreePlan;
    const canEditVisibility = permissions.canEditVisibility();
    const settingTitle = (React.createElement(SettingTitle, { showUpgradeBadge: canUpgrade, title: "Invite-only project" }));
    const disabledTooltipText = getInviteOnlyTooltip({
        isLockedFreePlan,
        isStarterPlan,
        canEditVisibility,
    });
    return (React.createElement(SettingsItem, Object.assign({ description: "Only visible to admins and collaborators added to this project", title: settingTitle }, settingItemProps),
        React.createElement(SettingsToggle, { disabledTooltipText: disabledTooltipText, isChecked: visibility === ProjectVisibility.Private, isDisabled: !!disabledTooltipText, onChange: onToggle, testId: "invite-only-toggle" })));
}
/**
 * BtwInviteOnlySetting
 */
export function BtwInviteOnlySetting({ onToggle, visibility, }) {
    const user = useCurrentUser();
    const permissions = usePermissions();
    const isLockedFreePlan = userSelectors.isLockedFreePlan(user);
    const isStarterPlan = userSelectors.isPro(user);
    const canUpgrade = isStarterPlan || isLockedFreePlan;
    const canEditVisibility = permissions.canEditVisibility();
    const disabledTooltipText = getInviteOnlyTooltip({
        isLockedFreePlan,
        isStarterPlan,
        canEditVisibility,
    });
    return (React.createElement(BtwSettingsItem, { "data-testid": "invite-only-toggle", description: "Only visible to admins and collaborators added to this project", disabled: !!disabledTooltipText, disabledTooltipText: disabledTooltipText, heading: React.createElement(SettingTitle, { showUpgradeBadge: canUpgrade, title: "Invite-only project" }), onPressedChange: onToggle, pressed: visibility === ProjectVisibility.Private, variant: "legacyBlue" }));
}
function SettingTitle({ title, showUpgradeBadge }) {
    const badge = showUpgradeBadge ? (React.createElement(Link, { href: "/plans?intent=invite-only-projects" },
        React.createElement(Badge, { variant: "outline", size: "sm" }, "Upgrade"))) : null;
    return (React.createElement(Stack, { direction: "row", align: "center", gap: "2" },
        title,
        badge));
}
function getInviteOnlyTooltip({ isLockedFreePlan, isStarterPlan, canEditVisibility, }) {
    if (isLockedFreePlan) {
        return 'Invite only projects are available on paid plans. Upgrade to unlock.';
    }
    if (isStarterPlan) {
        return 'Available on Business and Enterprise plans';
    }
    if (!canEditVisibility) {
        return "You don't have permissions to create invite-only projects";
    }
    return '';
}
